import { StorageKeys } from 'constants/constants';
import { getQueryParams } from 'utils/url';


const TWITCH_IMAGE_RATIO = .726315;

function parseScopes(scope) {
  if(scope && scope.length) {
    return _.chain(unescape(scope))
            .replace(/\+/gi, ' ')
            .split(" ")
            .value();
  }
  return scope;
}

function parseHash(hash) {
  let params = hash.substring(1);
  params = params.split("&").reduce((acc, v) => {
    let p = (v || "").split('=');
    if(p[0]) {
      return _.set(acc, p[0], _.isEmpty(p[1]) ? null : p[1]);
    }
  }, {});
  params.scope = parseScopes(params.scope);
  return params;
}

export function getTwitchAuthURL(clientId, scopes, redirectURL) {
  scopes = encodeURIComponent(scopes);
  redirectURL = encodeURIComponent(redirectURL);

  return `https://id.twitch.tv/oauth2/authorize?response_type=code&client_id=${clientId}&redirect_uri=${redirectURL}&scope=${scopes}`;
}

export function parseImageUrl(url, width = 125) {
  if(!url)
    return null;
  let height = Math.round(width / TWITCH_IMAGE_RATIO);
  return url.replace('{width}', width).replace('{height}', height);
}

export function openAuthWindow(url) {
  let authWin = window.open(url, "twitch-auth", "height=590, width=665");

  return new Promise((resolve, reject) => {
    window.addEventListener('storage', e => {
      if(e.key != StorageKeys.AUTH_CODE) 
        return;
      let url = e.newValue;
      let params = getQueryParams(url);
      if (params) {
        authWin?.close();
        params.scope = parseScopes(params.scope);
        return resolve(params);
      }
    });
  })
}